import * as React from 'react';
import { IAreaPart, IOffer } from '../../types/offer';
import { plural } from '@cian/utils';
import { getIsRent, getPrice } from '../area_parts/helpers';
const styles = require('./index.css');

export interface IAreaPartsProps {
  offer: IOffer;
  areaParts: IAreaPart[];
  onPageJumped(label?: string): void;
}

export function AreaParts({ areaParts, offer, onPageJumped}: IAreaPartsProps) {
  const areaText = areaParts && plural(areaParts.length - 3, ['площадь', 'площади', 'площадей']);
  const restPartsText = areaParts && `Ещё ${areaParts.length - 3} ${areaText}`;
  const { id, fullUrl, bargainTerms } = offer;
  const { paymentPeriod } = bargainTerms;

  return areaParts && (
    <div className={styles['row_area_parts']}>
      <ul className={styles['area_parts']}>
        {areaParts.slice(0, 3).map((area, index) => {
          const isRent = getIsRent(paymentPeriod || '');
          const price = getPrice(isRent, area);

          return (
            <li key={`${id}-area-part-${index}`} className={styles['area_parts_item']}>
              <a className={styles['area_parts_item_link']}
                 href={`${fullUrl}#/area-parts`}
                 target="_blank"
                 onClick={() => {
                   // tslint:disable-next-line: no-console
                   onPageJumped.bind(null, 'card_areas_in_newlist')();
                 }}>
                {`${area.area} м²`}
              </a>
              <div className={styles['area_parts_item_price']}>{price}</div>
            </li>
          );
        })}
        {areaParts && areaParts.length > 3 && (
          <li className={styles['area_parts_item-last']}>
            <a className={styles['area_parts_item_link']} href={`${offer.fullUrl}#/area-parts`} target="_blank"
               onClick={() => {
                 // tslint:disable-next-line: no-console
                 onPageJumped.bind(null, 'card_areas_in_newlist')();
               }}>
              {restPartsText}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}
